import { Card } from '@ics-portal/guardian';
import { type TableApi } from '@ics-portal/ics-data-table';
import { forwardRef, type ReactNode } from 'react';
import { useCardVisibility } from '@hooks/useCardVisibility';
import { RequestsHeader } from './RequestsHeader/RequestsHeader';
import { type RequestRow } from './RequestsTable/columns';
import { RequestsTable } from './RequestsTable/RequestsTable';

interface RequestsCardProps {
    selectedChange: (requests: RequestRow[]) => void;
}

export const RequestsCard = forwardRef<TableApi<RequestRow>, RequestsCardProps>(
    function RequestsCard({ selectedChange }, ref): ReactNode {
        const cardVisibility = useCardVisibility('notification-requests');

        return (
            <Card
                title="Requests"
                className="flex flex-column gap-4"
                {...cardVisibility}
            >
                <RequestsHeader />
                <RequestsTable ref={ref} selectedChange={selectedChange} />
            </Card>
        );
    },
);
